import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { Typography, Skeleton } from '@mui/material';
const HeaderSkeleton = () => {
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h3", sx: { width: '20%' }, children: _jsx(Skeleton, { animation: "wave" }) }), _jsx(Typography, { variant: "body1", sx: { width: '15%' }, children: _jsx(Skeleton, { animation: "wave" }) })] }));
};
export default HeaderSkeleton;
